import PropTypes from 'prop-types';

import isWebView from '#client/utils/isWebView';

const HideIfWebView = ({ children }) => (isWebView
  ? null
  : children);

HideIfWebView.propTypes = {
  children: PropTypes.node
};

HideIfWebView.defaultProps = {
  children: null
};

export default HideIfWebView;
